import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, inject, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonServices } from 'src/app/Common/CommonServices';
import { CustomServiceService } from 'src/app/Services/custom-service.service';
import { CardDetail, PaymentClient, User, API_BASE_URL } from 'src/app/Services/WOWApi.Service';
import { AddUpdatePaymentMethodComponent } from '../add-update-payment-method/add-update-payment-method.component';

@Component({
  selector: 'app-pyament-methods',
  standalone: false,
  templateUrl: './pyament-methods.component.html',
  styleUrl: './pyament-methods.component.css',
})
export class PyamentMethodsComponent implements OnInit {
  private readonly customServices = inject(CustomServiceService);
  private readonly paymentClient = inject(PaymentClient);
  private readonly commonServices = inject(CommonServices);
  private readonly snack = inject(MatSnackBar);
  private readonly dialog = inject(MatDialog);
  private readonly http = inject(HttpClient);
  private readonly baseUrl: string = inject(API_BASE_URL, { optional: true }) || '';

  loggedUser: User;
  savedCards: CardDetail[] = [];
  trackById = (_: number, c: CardDetail) => c.id;
  walletBalance: number = 0;
  isLoadingWallet: boolean = false;

  ngOnInit(): void {
    console.log('Payment methods component loaded');
    this.loggedUser = this.customServices.GetLoggedInUser();
    console.log(this.loggedUser);
    if (this.loggedUser !== undefined && this.loggedUser !== null) {
      this.getSavedCardDetails(this.loggedUser.id);
      this.loadWalletBalance();
    }
  }

  loadWalletBalance(): void {
    if (!this.loggedUser || !this.loggedUser.id) {
      return;
    }

    this.isLoadingWallet = true;
    const apiUrl = `${this.baseUrl}/api/Wallet/GetAvailableBalance/${this.loggedUser.id}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    this.http.get<number>(apiUrl, { headers }).subscribe(
      (balance: number) => {
        this.walletBalance = balance || 0;
        this.isLoadingWallet = false;
      },
      (error) => {
        // If wallet doesn't exist, balance is 0
        this.walletBalance = 0;
        this.isLoadingWallet = false;
        // Don't show error - wallet might not exist yet
      }
    );
  }

  getSavedCardDetails(userId: number) {
    this.paymentClient.getUserSavedCardDetails(userId).subscribe(res => {
      this.savedCards = res;
      console.log(this.savedCards);
    }, (error: HttpErrorResponse) => {
      this.commonServices.showMessage('Error', `${error.error}`);
    })
  }

  mask(num: string): string {
    if (!num) return '';
    const digits = num.replace(/\D/g, '');
    if (digits.length < 8) return digits;
    return `${digits.slice(0, 4)} **** **** ${digits.slice(-4)}`;
  }

  copyNumber(num: string) {
    const plain = num?.replace(/\D/g, '') ?? '';
    navigator.clipboard?.writeText(plain).then(
      () => this.snack.open('Card number copied', 'OK', { duration: 1500 }),
      () => this.snack.open('Copy failed', 'Dismiss', { duration: 2000 })
    );
  }

  toggleActive(card: CardDetail) {
    card.isActive = !card.isActive;    
    this.paymentClient.updateCardDetails(card.id, card).subscribe({
      next: data => {
        this.commonServices.showMessage('Success', 'Card status updated successfully');
        this.getSavedCardDetails(this.loggedUser.id);
      },
      error: (err: HttpErrorResponse) => {
        this.commonServices.showMessage('Error', err.message);
      }
    })
  }

  onEdit(card: CardDetail) {
    this.dialog.open(AddUpdatePaymentMethodComponent, {
      width: '480px',
      maxWidth: '92vw',
      height: 'auto',
      maxHeight: '90vh',
      panelClass: 'payment-method-dialog-panel',
      backdropClass: 'confirm-dialog-backdrop',
      autoFocus: false,
      data: { 
        userId: this.loggedUser.id ,
        card: card
      }
    }).afterClosed().subscribe(res => {
      if (res !== undefined && res !== null && res === 'success') {
        this.getSavedCardDetails(this.loggedUser.id);
      }
    });
  }

  onDelete(card: CardDetail) {
    this.paymentClient.deleteUserCardDetail(card.id).subscribe({
      next: data => {
        this.commonServices.showMessage('Success', 'Card deleted successfully');
        this.getSavedCardDetails(this.loggedUser.id);
      },
      error: (err: HttpErrorResponse) => {
        this.commonServices.showMessage('Error', err.message);
      }
    })
  }

  onAddCard() {
    this.dialog.open(AddUpdatePaymentMethodComponent, {
      width: '480px',
      maxWidth: '92vw',
      height: 'auto',
      maxHeight: '90vh',
      panelClass: 'payment-method-dialog-panel',
      backdropClass: 'confirm-dialog-backdrop',
      autoFocus: false,
      data: { 
        userId: this.loggedUser.id 
      }
    }).afterClosed().subscribe(res => {
      if (res !== undefined && res !== null && res === 'success') {
        this.getSavedCardDetails(this.loggedUser.id);
      }
    });
  }
}
